import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const briefcase: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5-10h4v-1H5Zm9 5v3.75q0 .516-.375.89c-.242.243-.531.36-.875.36H1.25C.906 0 .61-.117.36-.36A1.23 1.23 0 0 1 0-1.25V-5h5.25v1.25q0 .206.14.36.154.14.36.14h2.5q.201 0 .344-.14a.5.5 0 0 0 .156-.36V-5zM8-5v1H6v-1zm6-3.75v3H0v-3c0-.344.117-.633.36-.875Q.733-10 1.25-10H4v-1.25a.72.72 0 0 1 .219-.531A.72.72 0 0 1 4.75-12h4.5q.31 0 .531.219a.74.74 0 0 1 .219.531V-10h2.75c.344 0 .633.125.875.375q.375.361.375.875m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "12",
    width: "14",
  }
};